// cookie
export const setCookie = (name, value, config) => {
  let cookieStr = `${name}=${escape(value)}`;
  config = config || {};

  if (config.expiredays) {
    const exdate = new Date();
    exdate.setDate(exdate.getDate() + config.expiredays);
    cookieStr += `;expires=${exdate.toGMTString()}`;
  }
  if (config.path) {
    cookieStr += `;path=${config.path}`;
  }
  if (config.domain) {
    cookieStr += `;domain=${config.domain}`;
  }
  document.cookie = cookieStr;
};

export const getCookie = (name) => {
  const cookieArr = document.cookie.split('; ');
  for (let i = 0; i < cookieArr.length; i++) {
    const arr = cookieArr[i].split('=');
    if (arr[0] === name) {
      return arr[1];
    }
  }
};

/**
 * 生成uuid
 * @param {Number} len 生成uuid的长度
 * @param {Number} radix 生成uuid的格式
 * @return {String}
 */
export const uuidP = (len, radix) => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split(
    ''
  );
  const uuid = [];
  let i;

  radix = radix || chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    // rfc4122, version 4 form
    let r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }

  return uuid.join('');
};

// 协议id转uri
export const idToUri = (id) => {
  const protocol = 24;
  return String((id << 8) | protocol);
};

// 协议id转uri   42|24 -> 10776
export const toUri = (str) => {
  const [id, protocol] = String(str).split('|');
  return String((id << 8) | protocol);
};

// 2584 -> 10|24
export const toUri2 = (num) => {
  const leftNum = num >> 8;
  const rightNum = num - leftNum * 256;
  return `${leftNum}|${rightNum}`;
};

// 方便在控制面板解析协议
if (process.browser) {
  window.toUri2 = toUri2;
  window.toUri = toUri;
}

// 媒体灰度环境机器 103.211.231.127  103.211.231.136
export const ip2U32 = (ip) => {
  // ip = '103.211.231.127';
  let u32 = '';
  const ipList = ip.split('.').map((n) => ~~n);
  for (const n of ipList) {
    u32 += new Array(8 - n.toString(2).length + 1).join('0') + n.toString(2);
  }
  return parseInt(u32, 2);
};

// u32转ip
export const u322Ip = (u32) => {
  const ip = [];
  u32 = (+u32).toString(2);
  for (let i = 0; i < 4; ++i) {
    ip[i] = parseInt(u32.substr(i * 8, 8), 2);
  }
  return ip.join('.');
};

// charCode转字符串
export const decodeUtf8 = (buf) => {
  const u8view = new Uint8Array(buf);
  let matches;
  let str = '';
  for (const n of u8view) {
    str +=
      n < 128 && ~~n !== 37 ? String.fromCharCode(n) : `%${n.toString(16)}`;
  }
  try {
    str = decodeURIComponent(str);
  } catch (e) {
    // Sentry.captureMessage(
    //   `前端主动上报URI解释失败buf; Array: ${u8view}; String: ${str}`
    // );
  }
  if ((matches = str.match(/(\d+)[^{]*({.*})/))) {
    return {
      eid: ~~matches[1],
      data: JSON.parse(matches[2])
    };
  }
  return {};
};

// 字符串转charCode
export const encodeUtf8 = (text) => {
  const code = encodeURIComponent(text);
  const buf = [];
  for (let i = 0; i < code.length; i++) {
    const c = code.charAt(i);
    if (c === '%') {
      const hex = code.charAt(i + 1) + code.charAt(i + 2);
      const hexVal = parseInt(hex, 16);
      buf.push(hexVal);
      i += 2;
    } else {
      buf.push(c.charCodeAt(0));
    }
  }
  return new Uint8Array(buf);
};
